import { useEffect } from "react";

const STORAGE_KEY = "rw-onboarding-intent";
export const ONBOARDING_UPDATED_EVENT = "rw-onboarding-updated";
export const ONBOARDING_INTENT_EVENT = "rw-onboarding-intent";

export function setOnboardingIntent(intent) {
  if (!intent) {
    return;
  }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(intent));
  // Pages already on screen consume the intent through useOnboardingIntent;
  // a fresh mount consumes it from storage.
  if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
    window.dispatchEvent(new CustomEvent(ONBOARDING_INTENT_EVENT, { detail: intent }));
  }
}

export function consumeOnboardingIntent(expectedTab = null) {
  const rawValue = sessionStorage.getItem(STORAGE_KEY);
  if (!rawValue) {
    return null;
  }

  try {
    const intent = JSON.parse(rawValue);
    if (expectedTab && intent?.tab && intent.tab !== expectedTab) {
      return null;
    }
    sessionStorage.removeItem(STORAGE_KEY);
    return intent;
  } catch (error) {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

// Consume the onboarding intent for `tab` on mount and again whenever a new
// one is set while the page is already mounted (the Setup Assistant moves
// between sections of the same page, e.g. Locations -> Hours -> Labor Laws).
export function useOnboardingIntent(tab, handler, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const consume = () => {
      const intent = consumeOnboardingIntent(tab);
      if (intent) handler(intent);
    };
    consume();
    window.addEventListener(ONBOARDING_INTENT_EVENT, consume);
    return () => window.removeEventListener(ONBOARDING_INTENT_EVENT, consume);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, enabled]);
}
